import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
export function PricingSection() {
  return <section className="py-20 bg-[#EFF6FF] relative overflow-hidden" data-id="element-82">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-83">
        <div className="max-w-xl mx-auto" data-id="element-84">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-[#1B3A6B] rounded-3xl shadow-2xl overflow-hidden border-2 border-[#1B3A6B] text-white text-center relative" data-id="element-85">
            {/* Decorative circles */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-5 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-86" />
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#F97316] opacity-10 rounded-full translate-y-1/2 -translate-x-1/2" data-id="element-87" />

            <div className="p-8 sm:p-12 relative z-10" data-id="element-88">
              <p className="text-blue-200 font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-89">
                Oferta Especial — Tiempo Limitado
              </p>

              {/* Discount badge */}
              <div className="inline-block bg-[#F97316] text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-6" data-id="element-90">
                67% de descuento
              </div>

              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-91">
                <span className="text-3xl text-slate-400 line-through decoration-red-400 decoration-2" data-id="element-92">
                  $29.99
                </span>
                <span className="text-7xl font-bold font-oswald" data-id="element-93">$9.99</span>
              </div>

              <p className="text-blue-100 mb-8 text-sm" data-id="element-94">
                Un solo pago. Acceso inmediato.
              </p>

              <div className="mt-6 flex items-center justify-center gap-2 text-blue-200" data-id="element-95"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}